export const convertParams = (params) => {
    const ctd = {};
    if (!params) {
        return ctd;
    }
    if (params.has('model')) {
        ctd.model = params.getAll('model');
    }
    if (params.has('showroomNodeId')) {
        ctd.showroomNodeId = params.get('showroomNodeId') || undefined;
    }
    if (params.has('tenant')) {
        ctd.tenant = params.get('tenant') || undefined;
    }
    if (params.has('dimensionImagesTrim')) {
        ctd.dimensionImagesTrim = params.get('dimensionImagesTrim') || undefined;
    }
    if (params.has('defaultTrim')) {
        ctd.defaultTrim = params.get('defaultTrim') || undefined;
    }
    return ctd;
};
//# sourceMappingURL=convert-params.js.map